import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from '../../../shared/services/base.service';
import { SummaryCreditPolicyModel } from '../models/summary-credit-policy.model';



@Injectable()
export class CreditPolicyService extends BaseService<SummaryCreditPolicyModel,SummaryCreditPolicyModel> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/credit-policies');
  }

}
